import { render, staticRenderFns } from "./GroupMainInfo.vue?vue&type=template&id=c466e5de&scoped=true"
import script from "./GroupMainInfo.vue?vue&type=script&lang=js"
export * from "./GroupMainInfo.vue?vue&type=script&lang=js"
import style0 from "./GroupMainInfo.vue?vue&type=style&index=0&id=c466e5de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c466e5de",
  null
  
)

export default component.exports